// Copied from Acend
export type SpecialCase = { [key: string]: string };
export const enumSpecialCases: SpecialCase = {
  ACAT: "ACAT",
  ACATS: "ACATS",
  ACH: "ACH",
  ADR: "ADR",
  ALPHA: "ALPHA",
  ALPS: "ALPS",
  AML: "AML",
  AND: "and",
  ARE: "are",
  AS: "as",
  BD: "BD",
  BDW: "BDW",
  BY: "by",
  CDD: "CDD",
  CIP: "CIP",
  CLEANUP: "Clean-up",
  CM: "CM",
  CRD: "CRD",
  CUSIP: "CUSIP",
  DT: "DT",
  EIN: "EIN",
  EM: "EM",
  ETF: "ETF",
  FDIC: "FDIC",
  FEDEX: "FedEx",
  FIFO: "FIFO",
  FPSL: "FPSL",
  FROM: "from",
  FR: "FR",
  GF: "GF",
  ID: "ID",
  IM: "IM",
  IN: "in",
  IRA: "IRA",
  IRIS: "IRIS",
  IRS: "IRS",
  ITIN: "ITIN",
  JBO: "JBO",
  KYC: "KYC",
  LIFO: "LIFO",
  LM: "LM",
  MD: "MD",
  MPID: "MPID",
  MV: "MV",
  NSCC: "NSCC",
  OF: "of",
  OFAC: "OFAC",
  OMEGA: "OMEGA",
  OMNI: "OMNI",
  ON: "on",
  OR: "or",
  PDT: "PDT",
  PE: "PE",
  PEP: "PEP",
  PM: "PM",
  PREREFUNDED: "Pre-Refunded",
  PUT: "PUT",
  RCA: "RCA",
  RIA: "RIA",
  RT: "RT",
  RM: "RM",
  SEC: "SEC",
  SL: "SL",
  SSN: "SSN",
  TAF: "TAF",
  TEFRA: "TEFRA",
  TO: "to",
  US: "US",
  VIA: "via",
  WITH: "with",
  ZIP: "ZIP",
} as const;
